export const STORED_EMAIL_KEY = "pr-email";
export const STORED_LANG_KEY = "pr-lang";
export const STORED_ACCOUNT_NUMBER_KEY = "pr-account-number";
export const STORED_IS_HIGH_RISK_KEY = "pr-is-hr";
export const ACCOUNT_NUMBER_PARAMETER_KEY = `accountNumber`;
export const EMAIL_PARAMETER_KEY = `email`;
export const STORED_ACCOUNTS_KEY = "pr-accounts";
export const STORED_COUNTRY_KEY = "pr-country";
export const STORED_EBURY_REGULATORY_BRANCH_KEY = "pr-ebury-regulatory-branch";

const currentUrl = new URL(window.location.href);
export const isProduction = currentUrl.host === "periodic-reviews.ebury.com";
